import { render, staticRenderFns } from "./HomeDashboard.vue?vue&type=template&id=5c590c58&scoped=true"
import script from "./HomeDashboard.vue?vue&type=script&lang=js"
export * from "./HomeDashboard.vue?vue&type=script&lang=js"
import style0 from "./HomeDashboard.vue?vue&type=style&index=0&id=5c590c58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c590c58",
  null
  
)

export default component.exports